
import { initializeApp } from "firebase/app";
//import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
const firebaseConfig = {
  apiKey: "AIzaSyBDn8peDp31wo6kRiSMlOYY4Gs5JgFQeNw",
  authDomain: "dar-attaoui-a40e7.firebaseapp.com",
  projectId: "dar-attaoui-a40e7",
  storageBucket: "dar-attaoui-a40e7.firebasestorage.app",
  messagingSenderId: "1029414264432",
  appId: "1:1029414264432:web:bec81c5db49b0356c69eb5",
  measurementId: "G-QPCGQX3Z24"
};

const app = initializeApp(firebaseConfig);
//const analytics = getAnalytics(app);

const db= getFirestore(app);

export {db};